module.exports = __webpack_public_path__ + "files/9e1d72e7824838ff68132dd83f057ca2.png";